import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './RuleDefinition.module.scss';
import '../../../GlobalStyle.scss';

import TableRuleDefinition from './TableRuleDefinition';
import RuleDefinitionData from './RuleDefinitionData.json';
import crossIcon from '../../../fsa-style/img/crossIcon.svg';
import SuccessProcessGrowl from '../../../components/SuspenseQueue/SuccessProcessGrowl';
import { GlobalLoader } from '../../../newcomponents/GlobalLoader/GlobalLoader.js';
import Breadcrumb from '../../../newcomponents/Breadcrumb/Breadcrumb';
import { createRuleDefinition, deleteRuleDefinition, searchRuleDefinition, updateRuleDefinition } from './RuleDefinitionServices';
import { DeleteModal } from '../../../newcomponents/DeletePopup/DeleteModal';
import ErrorGrowl from '../../../components/SuspenseQueue/ErrorGrowl';
import CustomButton from '../../../newcomponents/CustomButton/CustomButton';
import SearchAdminPanelComponent from '../../../newcomponents/SearchAdminPanelComponent/SearchAdminPanelComponent';
import Footer from '../../../newcomponents/Footer/Footer';
import AsyncSelect from 'react-select/async';
import { handleMaxLimitError, handleIsRequiredError } from '../../../utils/helper/handleReuiredErrorFunc';
import { getSearchContextId } from '../RoutingSteps/RoutingStepsServices';

// var _ = require('lodash');

const breadcrumbData = [
  { title: 'Administrator Panel', link: '/admin' },
  { title: 'Rule Definition', link: '' },
];

export default function RuleDefinition() {
  // const [stepError, setStepError] = useState('');
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [recordModalShow, setRecordModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteData, setDeleteData] = useState();
  const [isNew, setIsNew] = useState(false);
  const [message, setMessage] = useState();
  const [isSuccessGrowlHidden, setIsSuccessGrowlHidden] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [sorting, setSorting] = useState({ column: '', order: '' });
  const [ruleDefinitionDetails, setRuleDefinitionData] = useState(RuleDefinitionData);

  const [formData, setFormData] = useState({
    ruleDisplayName: '',
    ruleType: '',
    ruleLevel: '',
    ruleDescription: '',
    confidence: true,
    editValue: true,
    saveEditValue: true,
    clipboard: true,
    clipboardable: true,
    visual: true,
    activeInd: true,
    contextId: '',
    ruleId: '',
  });
  const [searchText, setSearchText] = useState('');
  const [isErrorGrowlHidden, setIsErrorGrowlHidden] = useState(true);

  async function fetchRuleDefinitionData() {
    let payload = {
      text: searchText,
      column: sorting.column,
      order: sorting.order,
    };
    await searchRuleDefinition(payload).then((response) => {
      setData(response.data);
      setPage(0);
      setLoading(false);
    });
  }

  useEffect(() => {
    setLoading(true);
    fetchRuleDefinitionData();
  }, []);

  const onRemoveSort = async () => {
    setLoading(true);
    let payload = {
      text: searchText,
      column: '',
      order: '',
    };
    setSorting({ column: '', order: '' });

    await searchRuleDefinition(payload).then((response) => {
      setData(response.data);
      setPage(0);
      setLoading(false);
    });
  };

  const onPageChange = ({ page }) => {
    setPageSize(page.take);
    setPage(page.skip / page.take);
  };

  const createNewFunc = () => {
    setFormData({
      ruleDisplayName: '',
      ruleType: '',
      ruleLevel: '',
      ruleDescription: '',
      confidence: true,
      editValue: true,
      saveEditValue: true,
      clipboard: true,
      clipboardable: true,
      visual: true,
      activeInd: true,
      contextId: '',
      // ruleId: "ruleId091"
    });
    setIsNew(true);
    setRecordModalShow(true);
  };

  const DeleteDataFunc = (DeleteData) => {
    setLoading(true);
    const sendData = {
      ruleId: DeleteData.ruleId,
    };

    deleteRuleDefinition(sendData).then(async (response) => {
      if (response.data) {
        setDeleteModalShow(false);
        await fetchRuleDefinitionData();
        setLoading(false);
        setIsSuccessGrowlHidden(false);
        setMessage('Record deleted successfully');
        setTimeout(() => {
          setIsSuccessGrowlHidden(true);
        }, 3000);
      } else if (response.error) {
        setIsErrorGrowlHidden(false);
        setMessage(response.error.message ? response.error.message : 'Something went wrong');

        setTimeout(() => {
          setIsErrorGrowlHidden(true);
        }, 3000);
        console.log('error');
        setLoading(false);
      }
    });
  };

  const editFunc = (data) => {
    setFormData({
      ruleDisplayName: data.ruleDisplayName,
      ruleType: data.ruleType,
      ruleLevel: data.ruleLevel,
      ruleDescription: data.ruleDescription,
      confidence: data.confidence,
      editValue: data.editValue,
      saveEditValue: data.saveEditValue,
      clipboard: data.clipboard,
      clipboardable: data.clipboardable,
      visual: data.visual,
      activeInd: data.activeInd,
      contextId: data.contextId,
      ruleId: data.ruleId,
    });
    setIsNew(false);
    setRecordModalShow(true);
  };

  const DeleteFunc = (DeleteData) => {
    setDeleteModalShow(true);
    setDeleteData(DeleteData);
  };

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchText(value.trimStart());
    if (value.length > 2) onSearch(value);
    if (value.length === 0) onSearch(value);
  };

  const onSearch = async () => {
    setLoading(true);
    let payload = {
      text: searchText,
      column: sorting.column,
      order: sorting.order,
    };

    await searchRuleDefinition(payload).then((response) => {
      setData(response.data);
      setPage(0);
      setLoading(false);
    });
  };

  const clearSearch = async () => {
    setLoading(true);
    setSearchText('');
    setSorting({ column: '', order: '' });
    setLoading(false);
    // Clear sort from table header
    let newRuleDefinitionData = JSON.parse(JSON.stringify(ruleDefinitionDetails));
    newRuleDefinitionData.forEach((itm) => {
      itm.sortType = '';
    });
    setRuleDefinitionData(newRuleDefinitionData);
    await fetchNewRuleDefinitionData();
  };

  // Code needs to change
  const fetchNewRuleDefinitionData = async () => {
    let payload = {
      text: '',
      column: '',
      order: '',
    };
    await searchRuleDefinition(payload).then((response) => {
      setData(response.data);
      setPage(0);
      setLoading(false);
    });
  };

  const onSortData = async (selectedColumn) => {
    setLoading(true);
    let sortObj = {
      column: selectedColumn.field,
      order: selectedColumn.sortType,
    };
    setSorting(sortObj);
    let payload = {
      column: selectedColumn.field,
      order: selectedColumn.sortType,
      text: searchText,
    };
    await searchRuleDefinition(payload).then((response) => {
      setData(response.data);
      setLoading(false);
    });
  };

  return (
    <div className={styles.ruleDefinitionPage}>
      {isLoading && <GlobalLoader />}

      <Breadcrumb data={breadcrumbData} />
      <div className={styles.ruleDefinitionPageContent}>
        <h1 className={styles.pageTitle}>Rule Definition</h1>
        <div>
          <div className={styles.searchSection}>
            <div className={styles.keywordSearchTitle}>Keyword Search</div>
            <div className={styles.searchOuterContainer}>
              <div className="d-flex">
                <SearchAdminPanelComponent searchText={searchText} handleSearch={handleSearch} onSearch={onSearch} clearSearch={clearSearch}></SearchAdminPanelComponent>
              </div>
              <div>
                <CustomButton title="Create Record" className={styles.createRecordBtnStyle} onClick={createNewFunc} />
              </div>
            </div>
          </div>
        </div>
        <div className={[styles.ruleDefinitionTable, 'glbRuleDefinitionTable'].join(' ')}>
          <TableRuleDefinition
            data={data}
            page={page}
            editFunc={editFunc}
            DeleteFunc={DeleteFunc}
            pageSize={pageSize}
            fields={ruleDefinitionDetails}
            onPageChange={onPageChange}
            searchKeyword={searchText}
            setRecordModalShow={setRecordModalShow}
            setDeleteModalShow={setDeleteModalShow}
            onSortData={onSortData}
            onRemoveSort={onRemoveSort}
          />
        </div>
        <AddEditRuleDefinitionModal
          isNew={isNew}
          show={recordModalShow}
          formData={formData}
          setIsSuccessGrowlHidden={setIsSuccessGrowlHidden}
          setMessage={setMessage}
          setFormData={setFormData}
          setRecordModalShow={setRecordModalShow}
          onHide={() => setRecordModalShow(false)}
          isLoading={(e) => setLoading(e)}
          fetchRuleDefinitionData={fetchRuleDefinitionData}
        />
        {deleteModalShow && (
          <DeleteModal
            show={deleteModalShow}
            DeleteDataFunc={DeleteDataFunc}
            onHide={() => setDeleteModalShow(false)}
            setDeleteModalShow={setDeleteModalShow}
            selectedDeleteRowData={deleteData}
            setIsSuccessGrowlHidden={setIsSuccessGrowlHidden}
            setMessage={setMessage}
            popupTitle={'Rule Definition'}
          ></DeleteModal>
        )}
        <ErrorGrowl isErrorGrowlHidden={isErrorGrowlHidden} setIsErrorGrowlHidden={setIsErrorGrowlHidden} message={message} />
        <SuccessProcessGrowl isSuccessGrowlHidden={isSuccessGrowlHidden} setIsSuccessGrowlHidden={setIsSuccessGrowlHidden} message={message} />
      </div>
      {/* <Footer /> */}
    </div>
  );
}

// START:- Create / Edit record modal with functioanlity
const AddEditRuleDefinitionModal = (props) => {
  const [isRequiredError, setisRequiredError] = useState(false);
  // const [searchDataBUOW, setSearchDataBUOW] = useState([]);

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 32,
      minHeight: 32,
      width: '100%',
    }),
    menu: (base) => ({
      ...base,
      width: '100%',
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: 32,
      position: 'initial',
      padding: '0px 8px',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: 32,
    }),
    input: (provided, state) => ({
      ...provided,
      height: 32,
      padding: 0,
      margin: 0,
    }),
    container: (provided, state) => ({
      ...provided,
      minWidth: '100%',
    }),
  };

  useEffect(() => {
    setisRequiredError(false);
  }, [props.formData]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    props.setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    props.setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      if (
        !props.formData.contextId ||
        props.formData.contextId?.length > 50 ||
        props.formData.ruleDisplayName?.length > 100 ||
        props.formData.ruleType?.length > 50 ||
        props.formData.ruleLevel?.length > 50 ||
        props.formData.ruleDescription?.length > 100
      ) {
        setisRequiredError(true);
        return;
      }
      props.isLoading(true);
      await createRuleDefinition(props.formData)
        .then((response) => {
          if (response.data) {
            props.fetchRuleDefinitionData();
            props.setRecordModalShow(false);
            props.setIsSuccessGrowlHidden(false);
            props.setMessage('Record created successfully');

            setTimeout(() => {
              props.setIsSuccessGrowlHidden(true);
            }, 3000);
            props.isLoading(false);
          } else if (response.error) {
            props.setIsErrorGrowlHidden(false);
            props.setMessage(response.error.message ? response.error.message : 'Something went wrong');

            setTimeout(() => {
              props.setIsErrorGrowlHidden(true);
            }, 3000);
            props.isLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  const handleEdit = async () => {
    if (
      !props.formData.contextId ||
      props.formData.contextId?.length > 50 ||
      props.formData.ruleDisplayName?.length > 100 ||
      props.formData.ruleType?.length > 50 ||
      props.formData.ruleLevel?.length > 50 ||
      props.formData.ruleDescription?.length > 100
    ) {
      setisRequiredError(true);
      return;
    }
    props.isLoading(true);
    await updateRuleDefinition(props.formData).then((response) => {
      if (response.data) {
        props.setIsSuccessGrowlHidden(false);
        props.setMessage('Record updated successfully');

        setTimeout(() => {
          props.setIsSuccessGrowlHidden(true);
        }, 3000);

        props.fetchRuleDefinitionData();
        props.setRecordModalShow(false);
        props.isLoading(false);
      } else if (response.error) {
        props.setIsErrorGrowlHidden(false);
        props.setMessage(response.error.message ? response.error.message : 'Something went wrong');

        setTimeout(() => {
          props.setIsErrorGrowlHidden(true);
        }, 3000);
        props.isLoading(false);
      }
    });
  };

  const handleRadioChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    const booleanValue = value === 'true';
    props.setFormData((prevData) => ({
      ...prevData,
      [name]: booleanValue,
    }));
  };

  const onChangeContextId = (event) => {
    if (event == null)
      return props.setFormData((prevData) => ({
        ...prevData,
        contextId: '',
      }));
    const { value } = event;
    const updatedValue = value === '' ? null : value;
    props.setFormData((prevData) => ({
      ...prevData,
      contextId: updatedValue,
    }));
  };

  const loadContextIdList = async (inputValue, callback) => {
    if (inputValue === '') {
      // setSearchDataBUOW([]);
    } else {
      await getSearchContextId(inputValue).then(async (response1) => {
        let options = await response1.data.map((res) => {
          return { label: res.contextId, value: res.contextId };
        });
        // setSearchDataBUOW(options);
        callback(options);
      });
    }
  };

  return (
    <Modal
      {...props}
      className={[styles.ruleDefinitionModal, 'glbRuleDefinitionModalStyle'].join(' ')}
      backdropClassName="orc-modal-custom-backdrop"
      aria-labelledby="contained-modal-title-vcenter"
      size="lg"
      centered
      onHide={props.onHide}
    >
      <div>
        <Modal.Header>
          <div className={styles.modalHeader}>
            <div>
              <h2 className={styles.modalHeaderTitle}>{props.isNew ? 'Create Record' : 'Edit Record'}</h2>
            </div>
            <div
              className={styles.modalHeaderIcon}
              onClick={() => {
                props.setRecordModalShow(false);
              }}
            >
              <img src={crossIcon} alt="cross icon" />
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className={styles.ruleDefinitionModalBody}>
          <div className={styles.modalBodySection}>
            {!props.isNew && (
              <div className={styles.inputFieldSection}>
                <div className={[styles.inputFieldInternalDiv, 'col-12'].join(' ')}>
                  <label>Rule Id</label>
                  <input name="ruleId" value={props.formData.ruleId} onChange={handleInputChange} disabled={props.isNew ? false : true} />
                </div>
              </div>
            )}

            <div className={styles.inputFieldSection}>
              <div className={[styles.inputFieldInternalDiv, 'col-6'].join(' ')}>
                <label>Context Id *</label>
                <AsyncSelect
                  styles={customStyles}
                  isClearable
                  isDisabled={props.isNew ? false : true}
                  loadOptions={loadContextIdList}
                  value={props?.formData?.contextId !== '' ? { label: props?.formData?.contextId, value: props?.formData?.contextId } : null}
                  onChange={onChangeContextId}
                />
                {(props.formData.contextId === null || props.formData.contextId === '') && isRequiredError === true && handleIsRequiredError()}
                {props.formData.contextId.length > 50 && isRequiredError === true && handleMaxLimitError(50)}
              </div>
              <div className={[styles.inputFieldInternalDiv, 'col-6'].join(' ')}>
                <div className={styles.radioInputOuterDiv}>
                  <div>Confidence: </div>
                  <div style={{ display: 'flex' }}>
                    <input type="radio" name="confidence" value={true} checked={props.formData.confidence === true} onChange={handleRadioChange} /> True
                    <input type="radio" name="confidence" value={false} checked={props.formData.confidence === false} onChange={handleRadioChange} /> False
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.inputFieldSection}>
              <div className={[styles.inputFieldInternalDiv, 'col-6'].join(' ')}>
                <label>Rule Display Name</label>
                <input name="ruleDisplayName" value={props.formData.ruleDisplayName} onChange={handleInputChange} />
                {props.formData.ruleDisplayName.length > 100 && isRequiredError === true && handleMaxLimitError(100)}
              </div>
              <div className={[styles.inputFieldInternalDiv, 'col-6'].join(' ')}>
                <div className={styles.radioInputOuterDiv}>
                  <div>Edit Value: </div>
                  <div style={{ display: 'flex' }}>
                    <input type="radio" name="editValue" value={true} checked={props.formData.editValue === true} onChange={handleRadioChange} /> True
                    <input type="radio" name="editValue" value={false} checked={props.formData.editValue === false} onChange={handleRadioChange} /> False
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.inputFieldSection}>
              <div className={[styles.inputFieldInternalDiv, 'col-6'].join(' ')}>
                <label>Rule Type</label>
                <select className={styles.dropdownStyle} id="selectField" name="ruleType" value={props.formData.ruleType} onChange={handleSelectChange}>
                  <option value={''} disabled>
                    ---Select Type--
                  </option>
                  <option value="Match">Match</option>
                  <option value="Extract">Extract</option>
                  <option value="Validation">Validation</option>
                </select>
                {props.formData.ruleType.length > 50 && isRequiredError === true && handleMaxLimitError(50)}
              </div>
              <div className={[styles.inputFieldInternalDiv, 'col-6'].join(' ')}>
                <div className={styles.radioInputOuterDiv}>
                  <div>Save Edit Value: </div>
                  <div style={{ display: 'flex' }}>
                    <input type="radio" name="saveEditValue" value={true} checked={props.formData.saveEditValue === true} onChange={handleRadioChange} /> True
                    <input type="radio" name="saveEditValue" value={false} checked={props.formData.saveEditValue === false} onChange={handleRadioChange} /> False
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.inputFieldSection}>
              <div className={[styles.inputFieldInternalDiv, 'col-6'].join(' ')}>
                <label>Rule Level</label>
                <select className={styles.dropdownStyle} id="selectField" name="ruleLevel" value={props.formData.ruleLevel} onChange={handleSelectChange}>
                  <option value={''} disabled>
                    ---Select Level--
                  </option>
                  <option value="Mandatory">Mandatory</option>
                  <option value="Likely">Likely</option>
                  <option value="Possible">Possible</option>
                  <option value="Warning">Warning</option>
                  <option value="Informational">Informational</option>
                  <option value="Fatal">Fatal</option>
                </select>
                {props.formData.ruleLevel.length > 50 && isRequiredError === true && handleMaxLimitError(50)}
              </div>
              <div className={[styles.inputFieldInternalDiv, 'col-6'].join(' ')}>
                <div className={styles.radioInputOuterDiv}>
                  <div>Clipboard: </div>
                  <div style={{ display: 'flex' }}>
                    <input type="radio" name="clipboard" value={true} checked={props.formData.clipboard === true} onChange={handleRadioChange} /> True
                    <input type="radio" name="clipboard" value={false} checked={props.formData.clipboard === false} onChange={handleRadioChange} /> False
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.inputFieldSection}>
              <div className={[styles.inputFieldInternalDiv, 'col-6'].join(' ')}>
                <label>Rule Description</label>
                <input name="ruleDescription" value={props.formData.ruleDescription} onChange={handleInputChange} />
                {props.formData.ruleDescription.length > 100 && isRequiredError === true && handleMaxLimitError(100)}
              </div>
              <div className={[styles.inputFieldInternalDiv, 'col-6'].join(' ')}>
                <div className={styles.radioInputOuterDiv}>
                  <div>Visual: </div>
                  <div style={{ display: 'flex' }}>
                    <input type="radio" name="visual" value={true} checked={props.formData.visual === true} onChange={handleRadioChange} /> True
                    <input type="radio" name="visual" value={false} checked={props.formData.visual === false} onChange={handleRadioChange} /> False
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.inputFieldSection}>
              <div className={[styles.inputFieldInternalDiv, 'col-6'].join(' ')}>
                <div className={styles.radioInputOuterDiv}>
                  <div>Clipboard Able: </div>
                  <div style={{ display: 'flex' }}>
                    <input type="radio" name="clipboardable" value={true} checked={props.formData.clipboardable === true} onChange={handleRadioChange} /> True
                    <input type="radio" name="clipboardable" value={false} checked={props.formData.clipboardable === false} onChange={handleRadioChange} /> False
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.ruleDefinitionFooter}>
          <div className={styles.footerInternalDiv} style={{ gap: '3rem' }}>
            <CustomButton
              title="Cancel"
              className={styles.cancelRecordBtn}
              onClick={() => {
                props.setRecordModalShow(false);
              }}
            />

            {props.isNew ? (
              <CustomButton title="Save" className={styles.saveRecordBtn} onClick={handleSubmit} />
            ) : (
              <CustomButton title="Update" className={styles.saveRecordBtn} onClick={handleEdit} />
            )}
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  );
};
// END:- Create Edit record modal with functioanlity
